import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useSidebarStore = create(
  persist(
    (set) => ({
      isOpen: false,
      adminExpanded: false, // collapsed by default
      expandedGroups: {}, // { 'Core': true, 'User Engagement': false, ... }
      // Active nav mode for coaches (who are also students): 'coach' | 'student'.
      // null = not yet chosen; the Sidebar resolves the default (Coach for coaches).
      roleMode: null,
      setRoleMode: (mode) => set({ roleMode: mode }),
      toggle: () => set((state) => ({ isOpen: !state.isOpen })),
      close: () => set({ isOpen: false }),
      toggleAdminExpanded: () => set((state) => ({ adminExpanded: !state.adminExpanded })),
      toggleGroup: (groupName) =>
        set((state) => ({
          expandedGroups: {
            ...state.expandedGroups,
            [groupName]: !state.expandedGroups[groupName]
          }
        })),
      setGroupExpanded: (groupName, expanded) =>
        set((state) => ({
          expandedGroups: {
            ...state.expandedGroups,
            [groupName]: expanded
          }
        }))
    }),
    {
      name: 'sidebar-storage',
      partialize: (state) => ({
        adminExpanded: state.adminExpanded,
        expandedGroups: state.expandedGroups,
        roleMode: state.roleMode
      })
    }
  )
)

export default useSidebarStore
